import axios from 'axios';

const policyService = {
  /**
   * 获取政策法规列表
   * @param {Object} params - 查询参数
   * @param {number} params.page - 当前页码
   * @param {number} params.limit - 每页数量
   * @param {string} params.category - 政策分类
   * @returns {Promise} 返回政策法规列表数据
   */
  getPolicyList(params = {}) {
    return axios.get('/api/policies', {
      params,
      timeout: 5000
    });
  },

  /**
   * 获取单个政策法规详情
   * @param {number} id - 政策法规ID
   * @returns {Promise} 返回政策法规详情
   */
  getPolicyById(id) {
    return axios.get(`/api/policies/${id}`, {
      timeout: 5000
    });
  },

  /**
   * 获取上一篇和下一篇政策法规
   * @param {number} id - 当前政策法规ID
   * @returns {Promise} 返回上一篇和下一篇政策法规信息
   */
  getAdjacentPolicies(id) {
    return axios.get(`/api/policies/${id}/adjacent`, {
      timeout: 5000
    });
  }
};

export default policyService; 